import moment from 'moment';

export default {

    timeSince(date, shortFinalDate) {

        var post_date = moment.utc(date),
            now = moment(),
            seconds_passed = now.diff( post_date, 'seconds' ),
            minutes_passed = now.diff( post_date, 'minutes' );

        if( seconds_passed < 20 ) {
            return ' just now'
        } else if( seconds_passed < 60 ) {
            return seconds_passed.toFixed(0) + ' seconds ago'
        } else if( minutes_passed < 60 ) {
            return minutes_passed.toFixed(0) + ' minutes ago'
        } else if( minutes_passed < (90) ) {
            return 'Just over an hour ago'
        } else if( minutes_passed < (60 * 24) ) {
            return (minutes_passed / 60).toFixed(0) + ' hours ago'
        } else if( minutes_passed < (60 * 24 * 2) ) {
            return 'Yesterday'
        } else if( minutes_passed < (60 * 24 * 5) ) {
            return (minutes_passed / 60 / 24).toFixed(0) + ' days ago'
        } else {
            return shortFinalDate ? this.shortDate(date) : this.longDate(date)
        }

    },

    shortDate(date) {
        return moment(date).format('Do MMM')
    },

    shortDateTime(date) {
        return moment(date).format('Do MMM H:mm')
    },

    longDate(date) {
        return moment(date).format('MMMM Do, H:mm')
    },

    isWithinLastWeek(date) {

        if(!date) return false;

        var post_date = moment.utc(date),
            now = moment(),
            days_passed = now.diff( post_date, 'days' );

        return days_passed <= 2;

    }

}



// WEBPACK FOOTER //
// ./src/js/services/timestamps.js